import { FC } from 'react';

import { formatReleaseDate } from './gameReleaseDate';
import { Expansion } from '../../types';
import { cn } from '../../utils';

type Props = {
    fallbackImage?: string | null;
    onSelect: (releaseId: number) => void;
    releases: Expansion[];
    selectedReleaseId: number;
};

export const GameReleasesList: FC<Props> = ({
    fallbackImage,
    onSelect,
    releases,
    selectedReleaseId,
}) => (
    <div
        id="game-releases-list"
        className="scrollbar-hide flex gap-2 overflow-x-auto rounded-3xl border bg-card p-2 lg:h-full lg:flex-col lg:overflow-y-auto"
        data-testid="game-releases-list"
    >
        {releases.map((release) => {
            const active = release.id === selectedReleaseId;
            const thumbnail = release.image ?? fallbackImage;
            const itemReleaseDate = formatReleaseDate(release.released_on);

            return (
                <button
                    key={release.id}
                    type="button"
                    onClick={() => onSelect(release.id)}
                    aria-pressed={active}
                    data-testid={`game-release-${release.slug}`}
                    className={cn(
                        'group flex min-w-[17rem] cursor-pointer items-center gap-3 rounded-2xl border p-2 text-left transition-all focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-none lg:min-w-0',
                        active
                            ? 'border-primary bg-primary/5 shadow-sm'
                            : 'border-transparent hover:border-border hover:bg-accent/50',
                    )}
                >
                    <div className="relative h-16 w-28 shrink-0 overflow-hidden rounded-xl bg-muted">
                        {thumbnail ? (
                            <img
                                src={thumbnail}
                                alt=""
                                loading="lazy"
                                className="h-full w-full object-cover object-[center_22%] transition-transform duration-300 group-hover:scale-105"
                            />
                        ) : (
                            <div className="flex h-full items-center justify-center px-2 text-center text-xs font-bold text-muted-foreground">
                                {release.tag}
                            </div>
                        )}
                    </div>
                    <span className="min-w-0 flex-1">
                        <span className="block truncate font-semibold">
                            {release.name}
                        </span>
                        <span className="mt-1 block text-sm text-muted-foreground">
                            {itemReleaseDate ??
                                release.tag ??
                                'Дата уточнюється'}
                        </span>
                    </span>
                </button>
            );
        })}
    </div>
);
